import { render, staticRenderFns } from "./coupon-ad.vue?vue&type=template&id=21fcc35c&scoped=true&"
import script from "./coupon-ad.vue?vue&type=script&lang=ts&"
export * from "./coupon-ad.vue?vue&type=script&lang=ts&"
import style0 from "./coupon-ad.vue?vue&type=style&index=0&id=21fcc35c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fcc35c",
  null
  
)

export default component.exports